import { useContext, useEffect, useMemo, useState } from 'react';
import Box from '@mui/material/Box';
import { ReportTable } from '../components/reportTable';
import { getDataSource } from '../api/ds';
import { FindTextField } from '../components/FindTextField';
import { Tabs, Tab, styled, Typography, Button, Dialog, TextField, Divider } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Collapse, List, ListItemButton, ListItemText } from '@mui/material';
import { colors } from '../styles/colors';
import Paper from '@mui/material/Paper';
import { styleTable } from '../components/reportTable';
import { TabPanel } from '../components/tabPanel';
import useOn from 'components/socketLib/UseOn';
import { useDataContextDeal } from 'actions/contextDealClient';
import { useNavigate, unstable_usePrompt as usePrompt } from 'react-router-dom';
import { AddProducts } from 'components/AddProducts';
import { DateMenu } from 'components/RangeDate';
import { get, post } from 'api/apiBridges/httpBridge';
import { useSelector } from 'react-redux';
import { loginSelector } from 'store/slices/loginSlice';
import usePreventDoubleClick from 'components/AntiDBC';
import { SocketContext } from 'components/socketLib/ConnectorSocket';
import { MarketClientSelector } from 'store/slices/marketClient';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { useLocalNotifications } from 'components/Events';
import { SelectProductTocopy } from 'components/EIComponents/ProductInfo';
import { ShowModal } from "components/Modal";
import { getTMPVersion } from 'components/TechSpecif';
import { useBlocker } from 'react-router-dom';
import Loading from 'components/Load';
import { AddProductsForAdmin } from 'components/AddProductsForAdmin';
import { getNextItem } from 'utils/formatters';
import { hoverStyle } from "styles/main";
import _ from 'lodash';

// поставки по клиентам 
export function DeliveryAdmin() {
    const [isLoading, setLoading] = useState(true);
    // Состояние, указывающее, есть ли несохраненные изменения в форме
    const [isFormDirty, setIsFormDirty] = useState(false);
    // Флаг для перехода на другую страницу после успешной операции
    const [shouldNavigate, setShouldNavigate] = useState(false);
    // Данные
    /** @type {[Array<any>, Function]} */
    const [data, setData] = useState([]);
    const [MW, setMW] = useState(undefined);
    const [deal_id, setDeal_id] = useState(undefined);
    const [cli_id, setCli_id] = useState(undefined);
    const [market, setMarket] = useState(undefined);
    const [usedBarcodes, setUsedBarcodes] = useState([]);
     // Количество тюков
    const [countBale, setCountBale] = useState(1);
    // склад фулы и склад маркета
    const [warehouse_tranzit, setwarehouse_tranzit] = useState("");
    const [warehouse_market, setWarehouse_market] = useState("");
    const [pickup_addr, setPickup_addr] = useState("");
    const [pickup_contact, setPickup_contact] = useState("");
    const [pickup_sign, setPickup_sign] = useState("");
    // дата отгрузки
    const [date_shipment, setDate_shipment] = useState(new Date());
    // состояние ошибки, если пользователь напортачил
    const [error, setError] = useState(false);
    // Состояние для открытия модального окна добавления товара
    const [open, setOpen] = useState(false);
    // Навигационный хук из React
    const navigate = useNavigate();
    // получаем дескриптор
    const ds = useMemo(() => getDataSource('dealAdmin'), []);
    // получаем контекст с выбранными товарами
    const { dataContext, clearContextData } = useDataContextDeal();
    // const { socket } = useContext(SocketContext);-
    const { company_id, user_id  } = useSelector(
        loginSelector
      );
    const { showNotification } = useLocalNotifications();
    const preventDoubleClick = usePreventDoubleClick();
    const [openCopy, setOpenCopy] = useState(false);
    const [copyData, setCopyData] = useState(undefined)
    const [isDelivery, setDelivery] = useState(true);

    const blocker = useBlocker(
        ({ nextLocation, currentLocation }) =>
            isFormDirty && nextLocation.pathname !== currentLocation.pathname
    );

    
     // Хук для предупреждения пользователя при попытке уйти со страницы с несохраненными изменениями
    useEffect(() => {
        if (blocker.state === "blocked") {
            ShowModal(
                'Несохраненные изменения',
                <div>У вас есть несохраненные изменения. Вы уверены, что хотите покинуть страницу?</div>,
                async () => {
                    blocker.proceed(); 
                }
            );
        }
    }, [blocker]);

    // при необходимости перехода на другую страницу, если форма не заполнялась или сохранена
    useEffect(() => {
        if (shouldNavigate && !isFormDirty) {
            navigate('..', { relative: 'path', replace: true });
        }
    }, [shouldNavigate, isFormDirty, navigate]);

    // Функция создания новой поставки
    const create = async () => {
        setLoading(true)
        try {
            if (data.length === 0) {
                showNotification({
                    id: 'Null Products', 
                    type: 'error', 
                    message: 'Ни один товар не добавлен' 
                });
                return
            }

            let AvConsumes = undefined
            if (!isDelivery) {
                AvConsumes = await get('Deal/getAvConsumesCounts', {cid:cli_id})
            }

            const $data = [];
            let err = false
            let noComplectInTz = false
            let noComplectCount = false
            let units = 0
            for (const el of data) {
                // Собираем объект товара
                const item = { nmID: el.nmID, countProduct: el.countProduct, ...el.data, size: el.size };
                console.log("el.size", el.size)
                delete item.size.countQr
                let tz = {
                    text:item.size.techTask?.versions?.[item.size.techTask.TZV]?.text || undefined,
                    services:item.size.techTask?.versions?.[item.size.techTask.TZV]?.services || undefined,
                    print:item.size.techTask?.versions?.[item.size.techTask.TZV]?.print || undefined,
                    version: item.size.techTask.TZV
                }
                if (!tz.services && !tz.text) {
                    err = true
                    break
                }
                if (!isDelivery) {
                    let servIdx = tz.services.findIndex((fel) => fel.name === 'Комплектация товара')
                    if (servIdx === -1) {
                        noComplectInTz = true
                        break
                    }
                    //////////проверяем, хватает ли расходников
                    let tmpErr = false
                    tz.services[servIdx].data.consumes.map((cons) => {
                    if (!AvConsumes[`cons${cons.id}`] || AvConsumes[`cons${cons.id}`] < el.countProduct * cons.count) {
                        tmpErr = true
                    }
                    })
                    //Если хватает, чтобы добить товар, то вычитаем из расходников
                    if (!tmpErr) {
                        tz.services[servIdx].data.consumes.map((cons) => {AvConsumes[`cons${cons.id}`] -= el.countProductt * cons.count})
                    }
                    else {
                        noComplectCount = true
                        break
                    }

                }
                delete item.size.techTask
                item.size.techTask = tz
                units += parseInt(item.countProduct);
                $data.push(item);
            }

            if (err) {
                showNotification({
                    id: 'NOTZ', 
                    type: 'error', 
                    message: 'У некоторых товаров не указано техническое задание' 
                });
                return 
            }
            if (noComplectInTz) {
                showNotification({
                    id: 'NOTZComplect', 
                    type: 'error', 
                    message: 'У некоторых товаров не указаны расходники для комплектации' 
                });
                return 
            }
            if (noComplectCount) {
                showNotification({
                    id: 'NOTZComplectCount', 
                    type: 'error', 
                    message: 'Расходников недостаточно для сборки заявленного количества товаров' 
                });
                return 
            }
            await post("Deal/addProductsToDeal", {list: $data, deal_id, replace: false})
            setShouldNavigate(true);
            setIsFormDirty(false);
        }   
        catch (e) {
            console.log(e)
        }
        finally {
            setLoading(false)
        }
    }

    
    // Обработка изменений технического задания
    const changeTechText = async ($data, noNotif = false) => {
        console.log("$data", $data)
        if ($data.swap) {
            const found = data.findIndex((el) => String(el.id) === String($data.row.id))
            if (found !== -1) {
                data[found].size.techTask.TZV = $data.swap
            }
            return
        }
        if (!$data.copy) {
            const found = data.findIndex((el) => String(el.id) === String($data.row.id))
            if (found !== -1) {

                //запоминаем матаданные
                const barcode = data[found].size.techTask?.barcode;
                const title = data[found].size.techTask?.title
                const vendorCode = data[found].size.techTask?.vendorCode
                
                //Проверяем, существовала ли ранее такая версия
                const isCreating = !data[found].size.techTask || (
                    !data[found].size.techTask.versions[$data.version]?.text &&
                    !data[found].size.techTask.versions[$data.version]?.services &&
                    !data[found].size.techTask.versions[$data.version]?.print
                )
                // Выполняем запрос на создание
                if (isCreating) {
                    await post('techTask/create', {
                        barcode: barcode,
                        client_id: cli_id,
                        market,
                        text: $data.text,
                        services: $data.services,
                        print: $data.print,
                        version: $data.version,
                        comment: $data.comment,
                        fbs: $data.fbs,
                        hide: $data.hide
                    });
                    if (!noNotif) {
                        showNotification({
                        id: 'fieldsErr', 
                        type: 'success', 
                        message: 'ТЗ успешно создано' 
                        });
                    }
                } 
                else {
                    //Проверяем, нет ли уже существующих сделок с этим тз
                    let useInDeals = await get('Deal/checkTZ', {
                        tz: $data.version, 
                        nmID: data[found].nmID,
                        barcode: data[found].size.barcode,
                        market
                        }
                    )
                    //Если сделки с таким тз уже существуют и измененоо хотя бы одно из ключевых полей
                        //Создаем новую версию
                    if (
                        useInDeals.message &&
                        ( 
                        $data.text !== data[found].techTask.versions[$data.version]?.text ||
                        // $data.services !== data[found].techTask.versions[$data.version]?.services ||
                        !_.isEqual($data.services, data[found].techTask.versions[$data.version]?.services) ||
                        $data.print !== data[found].techTask.versions[$data.version]?.print
                        )
                    ) {
                        $data.version = `alt_${Object.keys(data[found].techTask.versions).length+1}`
                        await post('techTask/create', {
                            barcode: barcode,
                            client_id: cli_id,
                            market,
                            text: $data.text,
                            services: $data.services,
                            print: $data.print,
                            version: $data.version,
                            comment: $data.comment,
                            fbs: $data.fbs,
                            hide: $data.hide
                        });
                        showNotification({
                            id: 'fieldsErr', 
                            type: 'success', 
                            message: 'Альтернативаная версия ТЗ успешно создана' 
                        });
                    }
                    //Если же нет сделак с таком tz или не изменено ни одно из ключевых полей, то можем просто обновить его
                    else {
                        await post('techTask/update', {
                            barcode: barcode,
                            client_id: cli_id,
                            market,
                            text: $data.text,
                            services: $data.services,
                            print: $data.print,
                            version: $data.version,
                            comment: $data.comment,
                            fbs: $data.fbs,
                            hide: $data.hide
                        });
                        showNotification({
                            id: 'fieldsErr', 
                            type: 'success', 
                            message: 'ТЗ успешно обновлено' 
                        });
                    }
                }
                
                let updatedData = await get("techTask/getOnProduct", {bar: barcode, cid: cli_id, market: market})

                //Скрываем тз
                let tmpVersions = {}
                if (updatedData.versions) {
                    for (let vel of Object.keys(updatedData.versions)) {
                        if (!updatedData.versions[vel].hide || updatedData.versions[vel].verison === $data.version) {
                            tmpVersions[vel] = updatedData.versions[vel]
                        }
                    }
                }

                data[found].size.techTask = {
                    barcode: barcode,
                    title: title,
                    vendorCode:vendorCode,
                    versions: tmpVersions,
                    TZV: $data.version
                };

                setData(JSON.parse(JSON.stringify(data)));
            }
        }
        else {
            setCopyData(JSON.parse(JSON.stringify($data)))
            setOpenCopy(true)
        }
    }

    const copyTechTask = async (list) => {
        console.log(list)
        delete copyData.copy
        console.log("copyData", copyData)
        for (let el of list) {
            let versList = Object.keys(data.find((fel) => String(fel.id) === el).size.techTask.versions)
            await changeTechText({...copyData, version: getNextItem(versList), row: {id: el}}, true)
        }
        setCopyData(undefined)
        showNotification({
          id: 'succesCopy', 
          type: 'success', 
          message: 'ТЗ успешно скопировано' 
        });
    }

    const [allSKU, setAllSKU] = useState(0)
    const [allProduct, setAllProduct] = useState(0)

    const counttest = () =>{
        console.log("test", data)
        let allsku = 0
        let allproduct = 0
        if (data && data.length > 0){
            allsku = data.length
            for(let i = 0 ; i < data.length ; i++){
                allproduct += data[i].countProduct;
            }

        }
        
        setAllSKU(allsku)
        setAllProduct(allproduct)
    }

    useEffect(() => {
    counttest()
        }, [data]); 

    // Обработка полученного из контекста
    useEffect(() => {
        if (dataContext) {
            setLoading(true)
            setIsFormDirty(true);
            console.log("dataContext", dataContext)
            
            // setDelivery(dataContext.isDelivery)
            // предобработка данных под формат, чтобы отображать в таблице и редактировать
            let tmp = JSON.parse(JSON.stringify(data))
            for (const el of dataContext.deal) {
                let idx = tmp.findIndex((fel) => fel.nmID === el.nmID && fel.size.barcode === el.size.barcode)
                if (idx === -1) {
                    el.qrcode = { id: el.id, nmID: el.nmID, title: el.data.title, size: el.size, market: el.market, company: company_id, count: el.size.countQr, vendorCode: el.data.vendorCode};                  
                    if (dataContext.usedBarcodes.includes(el.size.barcode)) {
                        el.size.techTask = {blocked: "Для данного товара в этой сделке уже установленно тз"}
                    }
                    if (el.size.techTask) {
                        el.size.techTask.barcode = el.size.barcode; 
                        el.size.techTask.title = el.data.title; 
                        el.size.techTask.vendorCode = el.data.vendorCode
                        el.size.techTask.TZV = 'main'

                        //Скрытые версии
                        let tmpVersions = {}
                        if (el.size.techTask.versions) {
                            for (let vel of Object.keys(el.size.techTask.versions)) {
                                if (!el.size.techTask.versions[vel].hide || el.size.techTask.versions[vel].verison === el.size.techTask.TZV) {
                                    tmpVersions[vel] = el.size.techTask.versions[vel]
                                }
                            }
                        }
                        el.size.techTask.versions = tmpVersions
                    }
                    else {
                        el.size.techTask =  {
                            barcode: el.size.barcode, 
                            title: el.data.title, 
                            vendorCode: el.data.vendorCode,
                            TZV: 'main'
                        }
                    }
                    tmp.push(el)
                }               
                else {
                    tmp[idx].countProduct += el.countProduct
                } 
            }
            if (dataContext.multiWay) {
                setMW(dataContext.multiWay)
            }
            // Добавляем данные к текущему состоянию
            setData(tmp);
            setDeal_id(dataContext.deal_id)
            setCli_id(dataContext.cli_id)
            setMarket(dataContext.market)
            setUsedBarcodes(dataContext.usedBarcodes)
            counttest()
            clearContextData();
            setLoading(false)
        } else {
            // Если данных нет — возвращаемся на предыдущую страницу
            if (data.length === 0) {
                navigate('..', { relative: 'path', replace: true });
            }
        }
    }, [dataContext]);

    const del = async (id) => {
        let tmp = JSON.parse(JSON.stringify(data))
        let idx = tmp.findIndex((fel) => fel.id === id)
        if (idx > -1) {tmp.splice(idx, 1)}
        setData(tmp)
    }
    const handleClickDelProduct = (item) => {
        ShowModal('Удалить товар', 
        <div>Вы уверены, что хотите удалить товар?</div>, 
        async () => {
            try {
            del(item)
            }
            catch (err) {}
            finally {}
            
        });
    }

    console.log("data", data)

    return (
        <Box height="100%" display="flex" flexDirection="column" >
            <Dialog
                open={open}
                maxWidth={false}
                PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
                onClose={() => { setOpen(false) }}
            >
                <div style={{ height: '620px', width: '1200px', padding: '12px' }}>
                    <AddProductsForAdmin cancel={setOpen} cli_id={cli_id} deal_id={deal_id} market={market} usedBarcodes={usedBarcodes}></AddProductsForAdmin>
                </div>
            </Dialog>
            <Dialog
                open={openCopy}
                maxWidth='lg'
                PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
                onClose={() => { setOpenCopy(false) }}
            >
                <div style={{ height: '620px', width: '1000px', padding: '12px', }}>
                    <SelectProductTocopy data={data.filter((el) => el.id !== copyData?.row?.id)} cancel={setOpenCopy} onCopy={(list) => {copyTechTask(list)}}></SelectProductTocopy>
                </div>
            </Dialog>
            <Box sx={{display:'flex', flexDirection:'row', gap:2, paddingLeft:"10px", paddingRight:"10px", paddingBottom:1, paddingTop:1, backgroundColor:'white'}}>
                {/* {isDelivery && 
                    <div style={{display: "flex", flexDirection:"column", paddingLeft: "10px"}}>
                        <Typography variant='subtitle2' align='left' style={{marginBottom: "10px"}}>Забор товара</Typography>
                        <div style={{display: "flex", flexDirection:"row"}}>
                            <div style={{display: "flex", flexDirection:"column"}}>
                                <TextField value={pickup_addr} onChange={(e) => setPickup_addr(e.target.value)} style={{marginBottom: "10px"}} variant="outlined" size="small" inputProps={{ type: "string" }} label="Адрес для забора"></TextField>
                                <TextField value={pickup_contact} onChange={(e) => setPickup_contact(e.target.value)} style={{marginBottom: "10px"}} variant="outlined" size="small" inputProps={{ type: "string" }} label="Контакты"></TextField>
                            </div>
                            <div style={{display: "flex", flexDirection:"column", marginLeft:"10px"}}>
                                <TextField value={pickup_sign} onChange={(e) => setPickup_sign(e.target.value)} style={{marginBottom: "10px"}} variant="outlined" size="small" inputProps={{ type: "string" }} label="Подписание груза"></TextField>
                                <TextField
                                inputProps={{
                                    min: 1,
                                    max: 999999,
                                    type: "number",
                                }}
                                id="countBale"
                                label="Кол-во мест"
                                variant="outlined"
                                size="small"
                                // sx={{ width: "200px" }}
                                value={countBale}
                                onChange={(e) => {
                                    const value = parseInt(e.target.value);
                                    if (isNaN(value)) {
                                        setCountBale(1);
                                        setError(true);
                                    } else if (value < 1) {
                                        setCountBale(1);
                                        setError(true);
                                    } else if (value > 999999) {
                                        setCountBale(999999);
                                        setError(true);
                                    } else {
                                        setCountBale(value);
                                        setError(false);
                                    }
                                }}
                                onBlur={(e) => {
                                    if (!e.target.value || parseInt(e.target.value) < 1) {
                                        setCountBale(1);
                                    }
                                }}
                                error={error}
                                helperText={error ? "Допустимый диапазон: 1-999999" : ""}
                            />
                            </div>
                        </div>
                    </div>
                } */}
                {/* <div style={{ display:"flex", alignItems:"center"}}>
                    <Divider orientation="vertical" sx={{ borderRightWidth: "3px", height:"80%" }} />
                </div>
                <div>
                    <Typography variant='subtitle2' align='left' style={{marginBottom: "10px"}}>Отгрузка товара</Typography>
                    <TextField value={warehouse_market} onChange={(e) => setWarehouse_market(e.target.value)} style={{marginBottom: "10px"}} id="market" variant="outlined" size="small" inputProps={{ type: "string" }} label="Укажите название склада"></TextField>
                    <div style={{display:'flex', flexDirection:'row', gap:1, alignContent:'center', alignItems:'center', marginTop:"10px"}}>
                        <span>Дата отгрузки: </span>
                        <DateMenu date={date_shipment} onChange={setDate_shipment}/>
                    </div>
                </div> */}

                <div style={{ marginLeft: 'auto' }}>
                    <div style={{
                        display:'flex', 
                        flexDirection:'column',
                        gap: 5,
                        alignContent:'flex-start',
                        alignItems:'flex-start',
                        marginTop:"10px"
                    }}>
                        <span>Количество товара: {allProduct}</span>
                        <span>SKU: {allSKU}</span>
                    </div>
                </div>
            </Box>
            <Box flexGrow={1} overflow={'auto'}>
                {isLoading? <Loading></Loading>
                :
                <ReportTable 
                    ds={ds} 
                    data={data} 
                    onFormatterChange={changeTechText}
                    aditionalAction={
                        [
                            {
                                action: (item) => {handleClickDelProduct(item.id)},
                                ui: () => {return (
                                    <DeleteForeverIcon
                                        sx={{
                                            transition: 'all 0.3s ease',
                                            '&:hover': hoverStyle
                                        }}
                                    />
                                )}
                            }
                        ]
                    }
                />
                }
            </Box>
            <Box height="60px" display="flex" justifyContent="right" alignItems="center" px={2}>
                <Button variant="contained" onClick={() => { setOpen(true) }}
                    disabled={isLoading}
                    sx={{ textTransform: 'none', marginRight: '10px', backgroundColor: colors.elements, fontWeight: 'bold' }} >
                    Добавить товар
                </Button>
                <Button variant="contained"
                    onClick={preventDoubleClick(create, 1000)}
                    disabled={isLoading}
                    sx={{ textTransform: 'none', marginRight: '10px', backgroundColor: colors.elements, fontWeight: 'bold' }} >
                    Создать поставку
                </Button>
            </Box>
        </Box>

    );
}

